import React, { ErrorInfo, ReactNode } from 'react';
import styled from 'styled-components';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { logger } from '../logger';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message?: Error;
}

const background = tokens.colorAlertContainer;
const color = tokens.colorOnAlertContainer;

export class ElementErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(props: unknown) {
    return { hasError: true, message: props };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <StyledErrorFallBack>Error! {this.state.message?.toString()}</StyledErrorFallBack>;
    }

    return this.props.children;
  }
}

const StyledErrorFallBack = styled.div`
  padding: 12px 0 12px 10px;
  font-weight: bold;
  position: relative;
  background: ${background};
  border: 1px solid ${color};
  color: ${color};
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
`;
